export interface MedplumAppConfig {
  baseUrl?: string
  middlewareUrl: string
  clientId?: string
  googleClientId?: string
  recaptchaSiteKey?: string
  registerEnabled?: boolean | string
  awsTextractEnabled?: boolean | string
  patientPortalUrl?: string
  marketingSiteUrl: string
  googleMapsBrowserKey?: string
}

export const config: MedplumAppConfig = {
  baseUrl: import.meta.env?.MEDPLUM_BASE_URL,
  middlewareUrl: import.meta.env?.VITE_MIDDLEWARE_URL ?? import.meta.env?.MIDDLEWARE_URL,
  clientId: import.meta.env?.MEDPLUM_CLIENT_ID,
  googleClientId: import.meta.env?.GOOGLE_CLIENT_ID,
  recaptchaSiteKey: import.meta.env?.RECAPTCHA_SITE_KEY || import.meta.env?.CAPTCHA_SITE_KEY,
  registerEnabled: import.meta.env?.MEDPLUM_REGISTER_ENABLED,
  awsTextractEnabled: import.meta.env?.MEDPLUM_AWS_TEXTRACT_ENABLED,
  patientPortalUrl: import.meta.env?.VITE_PATIENT_PORTAL_URL,
  marketingSiteUrl: import.meta.env?.VITE_MARKETING_SITE_URL ?? 'https://www.behuman.health',
  googleMapsBrowserKey: import.meta.env?.VITE_GOOGLE_MAPS_BROWSER_KEY,
}

export function getConfig(): MedplumAppConfig {
  return config
}

export function isRegisterEnabled(): boolean {
  return isFeatureEnabled('registerEnabled')
}

export function isAwsTextractEnabled(): boolean {
  return isFeatureEnabled('awsTextractEnabled')
}

function isFeatureEnabled(feature: keyof MedplumAppConfig): boolean {
  // This try/catch exists to prevent Rollup optimization from removing this function
  try {
    return config[feature] !== false && config[feature] !== 'false'
  } catch {
    return true
  }
}
